var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKitchenPackSpoonSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_3235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.57366 0.21875C2.26427 0.21875 0.530273 2.62011 0.530273 4.76717V6.68384C0.530273 8.62869 1.92016 10.2565 3.75443 10.6355V23.2073C3.75443 23.6452 4.10941 24.0001 4.54727 24.0001C4.98513 24.0001 5.34012 23.6451 5.34012 23.2073V10.6446C7.1988 10.2848 8.6171 8.64603 8.6171 6.68384V4.76717C8.61705 2.62006 6.8831 0.21875 4.57366 0.21875ZM7.03141 6.6838C7.03141 8.03441 5.92427 9.13316 4.57366 9.13316C3.22305 9.13316 2.11591 8.03436 2.11591 6.6838V4.76713C2.11591 3.42514 3.21687 1.80434 4.57366 1.80434C5.93046 1.80434 7.03141 3.42514 7.03141 4.76713V6.6838Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5455 0C16.1076 0 15.7526 0.354984 15.7526 0.792844V7.64391C15.7526 8.17524 15.3411 8.61928 14.8098 8.61928H14.6427V0.792844C14.6427 0.354984 14.2877 0 13.8499 0C13.412 0 13.057 0.354984 13.057 0.792844V8.61928H12.8498C12.3185 8.61928 11.8942 8.17528 11.8942 7.64391V0.792844C11.8942 0.354984 11.5393 0 11.1014 0C10.6636 0 10.3086 0.354984 10.3086 0.792844V7.64391C10.3086 9.0496 11.4441 10.2049 12.8498 10.2049H13.057V23.1728C13.057 23.6107 13.412 23.9657 13.8499 23.9657C14.2877 23.9657 14.6427 23.6107 14.6427 23.1728V10.2049H14.8098C16.2155 10.2049 17.3383 9.04964 17.3383 7.64391V0.792844C17.3383 0.354984 16.9834 0 16.5455 0Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.575 0.578759C21.1458 0.200853 20.555 0.112353 20.0338 0.3479C19.5126 0.5834 19.1885 1.08501 19.1885 1.65693V23.1734C19.1885 23.6112 19.5435 23.9662 19.9813 23.9662C20.4192 23.9662 20.7742 23.6112 20.7742 23.1734V15.1723L23.11 13.6403C23.3333 13.4937 23.4698 13.2446 23.4698 12.9775V4.76376C23.4696 3.16237 22.7769 1.63696 21.575 0.578759ZM21.884 12.5496L20.774 13.2755V2.00667C21.4611 2.74579 21.884 3.73279 21.884 4.76376V12.5496Z",
    fill: "#9393B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_3235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenPackSpoonSvgrepocom);
export default __webpack_public_path__ + "static/media/kitchen-pack-spoon_svgrepo.com.0a0129c90605f986fb961fdabd856a0c.svg";
export { ForwardRef as ReactComponent };